const OrangeTriangle = (): JSX.Element => (
  <svg
    role="img"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Orange Triangle Icon</title>
    <path d="M1.66948e-07 -1.66948e-07L14 0L14 14L1.66948e-07 -1.66948e-07Z" fill="#F26924" />
  </svg>
);

export default OrangeTriangle;
